import { ViewConeIcon as L2RViewConeIcon } from "@l2r-front/l2r-icons"
import { styled } from "@l2r-front/l2r-ui"

export const ViewConeIcon = styled(L2RViewConeIcon, {
    shouldForwardProp: (prop) => prop !== "color" && prop !== "rotation",
})(({ color, rotation }) => ({
    color: color,
    display: "block",
    height: 60,
    pointerEvents: "none",
    transform: `rotate(${rotation}deg)`,
    transformOrigin: "50% 100%",
    width: 60,
}))